export enum WPFMessageType {
    DownloadImages = 'download-images',
    BatchImageDownloadComplete = 'batch-image-download-complete',
    ShutdownTimeout = 'shutdown-timeout',
    Shutdown = 'shutdown',
    Restart = 'restart',
    AudioDeviceChange = 'audio-device-change',
    HeadphoneInOut = 'headphone-in-out',
}

export enum UsbMediaConnectStatus {
    Connected = 'connected',
    Disconnected = 'disconnected',
}
